export const MAX_RETRIES = 3;
export const RETRY_DELAY = 1000;

export const VENDOR_VALIDATION = {
  NAME_MIN_LENGTH: 2,
  ADDRESS_MIN_LENGTH: 5,
  PHONE_REGEX: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
  EMAIL_REGEX: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
} as const;